import PanelNavigator from "../../component/panelNavigator/PanelNavigator";
import { BackButton } from "../buttonComponent/ButtonComponent";
import { useAuth } from "../../config/utilities/useAuth";
import {
  CMS_AUDIT_ROLES,
  NAV_BAR_BACK_LABELS,
  NAV_BAR_SUB_NAV,
} from "../../config/navConfig";
import { useOutletContext } from "react-router-dom";
import "./NavBar.css";

const CMS_MODULE_KEYS = [
  "serviceAnnouncement",
  "busPolicy",
  "generalPolicy",
];

export default function NavBar({ type, action, handleReset }) {
  const { privilege } = useAuth();
  const outletContext = useOutletContext() || {};
  const openSidebar = outletContext.openSidebar;
  const modules = privilege?.modules;
  const role = privilege?.role;

  const getBackLabel = () => NAV_BAR_BACK_LABELS[type] ?? "Main Page";

  const renderNavItems = () => {
    if (
      action === "edit" ||
      action === "create" ||
      action === "view" ||
      action === "daily"
    ) {
      return (
        <BackButton
          label={`Back to ${getBackLabel()}`}
          btnClickBack={handleReset}
          fontSize="0.875rem"
          color="#101828"
          backgroundColor="#FFF"
        />
      );
    }

    return (
      <>
        {NAV_BAR_SUB_NAV[type]
          ?.filter((item) => {
            if (!item.key) return true;

            if (
              item.key === "auditLogs" ||
              CMS_MODULE_KEYS.includes(item.key)
            ) {
              return CMS_AUDIT_ROLES.includes(role);
            }

            return modules[item.key];
          })
          .map((item) => (
            <PanelNavigator key={item.path} text={item.text} path={item.path} />
          ))}
      </>
    );
  };

  return (
    <div className="navbar-container">
      <button
        type="button"
        className="navbar-mobile-menu-button"
        onClick={() => openSidebar?.()}
        aria-label="Open sidebar"
      >
        <span className="navbar-mobile-menu-icon" />
        <span className="navbar-mobile-menu-icon" />
        <span className="navbar-mobile-menu-icon" />
      </button>
      <div className="navbar-item">{renderNavItems()}</div>
    </div>
  );
}
